import { avatar } from "./avatar"
import { button } from "./button"
import { table } from "./table"
import { menuItem } from "./menuItem"
import { heading, text } from "./typography"
import { form } from "./form"

export const components = {
  Avatar: avatar,
  Button: button,
  Table: table,
  MenuItem: menuItem,
  Heading: heading,
  Text: text,
  Form: form
}
